<template>
	<form @submit.prevent="createPackage()">
		<h4 class="mb-5 text-dark custom-rounded-15 shadow-sm fs-2 p-4">
			Create Package
		</h4>
		<div class="row">
			<div class="col-sm-8">
				<div class="row">
					<h5 class="col-md-12 shadow-sm custom-rounded-15 text-dark py-3">
						Package Information
					</h5>
					<div class="form-group col-sm-6 mb-5">
						<BaseInput
							name="Package Name"
							label="Package Name"
							type="text"
							v-model="data.name"
							class="form-control form-control-lg dashInput"
							rules="required|min:5"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-5">
						<BaseMultiSelect
							@update:value="setCountry"
							:options="multiSelectState.countriesSelect"
							rules="required"
							name="Country"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<h5
						class="col-md-12 custom-rounded-15 shadow-sm text-dark d-flex justify-content-between align-items-center py-3"
					>
						Cities
						<button
							type="button"
							@click="addComponent"
							class="btn btn-danger btn-sm shadow-sm"
						>
							Add Stay
						</button>
					</h5>
					<div
						v-for="(count, index) in componentCount.count"
						:key="`${count}-stay`"
						class="col-md-6"
					>
						<CityStay
							:id="count"
							:nameIndex="index"
							:country="data.country.name"
							@removeComponent="removeComponent"
							@updateData="updateData"
						/>
					</div>
					<h5 class="col-md-12 mt-4 text-dark custom-rounded-15 shadow-sm py-3">
						Tags
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<BaseMultiSelect
							@update:value="setTags"
							:options="multiSelectState.tagsSelect"
							rules="required"
							name="Tags"
							mode="tags"
							:closeOnSelect="false"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-sm py-3 mt-4">
						Overview
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<textarea
							class="form-control form-control-lg"
							v-model="data.overview"
						></textarea>
					</div>

					<h5
						class="col-md-12 text-dark custom-rounded-15 text-dark shadow-sm py-3 mt-4"
					>
						Meal Type
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<div
							v-for="(meal, index) in radioCheckData.mealType"
							:key="`${index}-meal`"
							class="form-check form-check-inline"
						>
							<input
								class="form-check-input"
								type="radio"
								name="meal"
								:id="`mealRadio${index}`"
								:value="meal"
								v-model="data.meal"
							/>
							<label
								class="form-check-label text-dark"
								for="mealRadio${index}"
								>{{ meal }}</label
							>
						</div>
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-sm mt-5 py-3">
						Other
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<div
							v-for="(other, index) in radioCheckData.inclusion"
							:key="`${index}-other`"
							class="form-check form-check-inline"
						>
							<input
								class="form-check-input"
								type="checkbox"
								:id="`Checkbox${other}`"
								:value="other"
								v-model="data.other"
							/>
							<label
								class="form-check-label text-dark"
								for="`Checkbox${other}`"
								>{{ other }}</label
							>
						</div>
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-sm mt-4 py-3">
						Itinerary
					</h5>
					<div class="form-group col-sm-6 mb-5">
						<input
							class="form-check-input"
							v-model="data.itinerary"
							type="checkbox"
							value=""
							id="flexCheckIndeterminate"
						/>
						<label
							class="form-check-label mx-2 text-dark"
							for="flexCheckIndeterminate"
						>
							Do You Want to Create Itinerary?
						</label>
					</div>

					<!-- <div class="col-sm-12">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="image.enabled"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload package image</label
							>
						</div>
					</div>

					<div v-if="image.enabled" class="col-sm-12">
						<BaseImageUpload urlParam="packages" @images-data="setImage" />
					</div> -->

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-sm mt-4 py-3">
						The Package Price Includes
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor @updateData="setInclusion" :required="true" />
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-sm mt-4 py-3">
						The Package Price Excludes
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor @updateData="setExclusion" :required="true" />
					</div>

					<!-- <h5 class="col-md-12 text-dark custom-rounded-15 shadow-sm mt-4 py-3">
						Package Prices
					</h5>
					<div class="form-group col-sm-6 mb-5">
						<BaseInput
							name="Season Price"
							label="Season Price"
							type="number"
							:min="2000"
							v-model="data.seasonPrice"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div class="form-group col-sm-6 mb-5">
						<BaseInput
							name="Off Season Price"
							label="Off Season Price"
							type="number"
							:min="2000"
							v-model="data.offSeasonPrice"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div> -->
					<div class="col-sm-12 my-5">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="data.seasonDatesBool"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Add Season Dates</label
							>
						</div>
					</div>
					<div v-if="data.seasonDatesBool" class="col-sm-12 pt-4">
						<div class="row">
							<h3>High Season</h3>
						</div>
						<div class="row">
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season Start"
									type="text"
									v-model="seasonDates.seasonOne.startDate"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season end"
									type="text"
									v-model="seasonDates.seasonOne.endDate"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
						</div>

						<div class="row">
							<h3>Mid Season</h3>
						</div>
						<div class="row">
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season Start"
									type="text"
									v-model="seasonDates.seasonTwo.startDate"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season end"
									type="text"
									v-model="seasonDates.seasonTwo.endDate"
									class="form-control form-control-lg dashInput"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
						</div>

						<div class="row">
							<h3>Low Season</h3>
						</div>
						<div class="row">
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season Start"
									type="text"
									v-model="seasonDates.seasonThree.startDate"
									class="form-control form-control-lg dashInput"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season end"
									type="text"
									v-model="seasonDates.seasonThree.endDate"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
						</div>
					</div>

					<div class="col-sm-12 my-5">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="data.includedDeal"
								type="checkbox"
								id="packageDeal"
							/>
							<label class="form-check-label text-dark" for="packageDeal"
								>Add Package Deals</label
							>
						</div>
					</div>

					<Transition>
						<div v-if="data.includedDeal" class="row">
							<div class="row my-5">
								<h4>Bronze Package</h4>
								<PackageDeal
									v-for="(city, index) in data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="bronze"
									:city="city.city"
									:defaultData="data.bronzePackage"
									@updateData="setBronzePackage"
									@removeData="removePackage"
								/>
							</div>
							<div class="row my-5">
								<h4>Platinum Package</h4>
								<PackageDeal
									v-for="(city, index) in data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="platinum"
									:city="city.city"
									:defaultData="data.platinumPackage"
									@updateData="setPlatinumPackage"
									@removeData="removePackage"
								/>
							</div>
							<div class="row my-5">
								<h4>Silver Package</h4>
								<PackageDeal
									v-for="(city, index) in data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="silver"
									:city="city.city"
									:defaultData="data.silverPackage"
									@updateData="setSilverPackage"
									@removeData="removePackage"
								/>
							</div>
							<div class="row my-5">
								<h4>Gold Package</h4>
								<PackageDeal
									v-for="(city, index) in data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="gold"
									:city="city.city"
									:defaultData="data.goldPackage"
									@updateData="setGoldPackage"
									@removeData="removePackage"
								/>
							</div>
							<div class="row my-5">
								<h4>Luxury Package</h4>
								<div class="packageWrapper">
									<PackageDeal
										v-for="(city, index) in data.cities"
										:key="`${city.city.name}-${index}`"
										:id="index"
										dealName="luxury"
										:city="city.city"
										:stay="city.stayNights"
										:defaultData="
											data.luxuryPackage.length ? data.luxuryPackage[index] : ''
										"
										@updateData="setLuxuryPackage"
										@removeData="removePackage"
									/>
								</div>
							</div>
						</div>
					</Transition>

					<div class="form-group col-sm-12 mt-2">
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Save Package"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div class="col-sm-4 px-4">
				<h4 class="text-dark fs-4">Global Trip Holidays</h4>
				<p class="text-dark">
					Contacts are your customers you interact with in pursuit of a business
					opportunity.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, inject } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseButton from "./BaseButton.vue";
	import BaseEditor from "./BaseEditor.vue";
	import CityStay from "./CityStay.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import Itinerary from "./CreateItinerary.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";
	import PackageDeal from "./PackageDeal.vue";

	import Helper from "@/helpers/dataHelper";
	import FormCheck from "@/helpers/formCheckHelper";

	export default {
		name: "PackageCreate",
		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			CityStay,
			BaseFileInput,
			Itinerary,
			BaseEditor,
			BaseImageUpload,
			PackageDeal,
		},

		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");
			const packageEditState = inject("packageEditState");

			const router = useRouter();

			if (!store.state.auth.isAuth) router.push({ name: "Login" });

			const data = reactive({
				name: null,
				country: {},
				cities: [],
				tags: [],
				overview: null,
				meal: null,
				itinerary: false,
				other: [],
				images: [],
				inclusions: null,
				exclusions: null,
				seasonPrice: 0,
				offSeasonPrice: 0,
				seasonDatesBool: false,
				seasonDates: {},
				includedDeal: false,
				luxuryPackage: [],
				goldPackage: [],
				silverPackage: [],
				platinumPackage: [],
				bronzePackage: [],
			});

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],

				states: [],

				tags: [],
				tagsSelect: [],

				transports: [],
				transportSelect: [],
			});

			const seasonDates = reactive({
				seasonOne: { startDate: "", endDate: "" },
				seasonTwo: { startDate: "", endDate: "" },
				seasonThree: { startDate: "", endDate: "" },
			});

			const radioCheckData = reactive({
				mealType: [],
				inclusion: [],
			});

			radioCheckData.mealType = Helper.mealType;
			radioCheckData.inclusion = Helper.otherData;

			const formState = reactive({
				isLoading: false,
				disable: false,
			});
			const image = reactive({
				enabled: false,
			});
			const componentCount = reactive({ count: [1] });

			const nullable = [
				"images",
				"overview",
				"cities",
				"inclusions",
				"exclusions",
				"tags",
				"other",
			];

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};

			const getState = async (stateObj = false) => {
				let apiObj = {};
				if (stateObj instanceof Object && stateObj?.name.length < 3) return;
				if (stateObj instanceof Object && stateObj?.name)
					apiObj.name = stateObj.name;

				if (data?.country?.name) apiObj.countryName = data.country.name;
				try {
					const states = await Helper.getStates(apiObj);
				} catch (error) {
					console.log("error fetching states: :(");
				}
			};

			// ? setting country
			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country = { id: 0, name: null };
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				// ? changing state value without re-render
				data.country = { id: country[0].id, name: country[0].name };
			};

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("tags");
					const changedTags = response.data.data.map((tag) => ({
						value: tag._id,
						label: tag.name,
					}));
					multiSelectState.tags = response.data.data;
					multiSelectState.tagsSelect = changedTags;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}

					toast.error(message, true);
				}
			};

			// ? setting selected tags in state
			const setTags = (value) => {
				let selectedID = Object.values(value);

				const selectedTag = multiSelectState.tags.flatMap((tag) => {
					let selected = selectedID.map((id) => {
						if (tag._id === id) {
							let data = { id: tag._id, name: tag.name };
							return data;
						}
					});

					return selected;
				});

				data.tags = selectedTag.filter(Boolean);
			};

			getCountries();
			getTags();

			const setExclusion = (payload) => {
				data.exclusions = payload;
			};
			const setInclusion = (payload) => {
				data.inclusions = payload;
			};

			const createPackage = async () => {
				changeFormLoadingState();
				formState.disable = true;

				// if (validation.invalid.length) {
				// 	toast.error("Incomplete form", true);
				// 	changeFormLoadingState();
				// 	return;
				// }

				if (data.seasonDatesBool) {
					data.seasonDates = { ...seasonDates };
				} else {
					data.seasonDates = {
						seasonOne: { startDate: "", endDate: "" },
						seasonTwo: { startDate: "", endDate: "" },
						seasonThree: { startDate: "", endDate: "" },
					};
				}

				if (data.itinerary) {
					packageEditState.state.data = data;
					masterStore.methods.changeData(data);
					masterStore.methods.changeComponent("itinerary");
					return;
				}

				try {
					await API.privateRequest.post("packages", data);
					toast.success(
						{ message: "Package Success!", position: "topRight" },
						true,
					);
					changeFormLoadingState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error !";
					}
					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
				}
			};

			// event handler for input validation event
			const inputError = (input) => {
				// let check = FormCheck.valError(input, data, nullable);
				// console.log("input error: ::");
				// console.log(check);
				// formState.disable = check;
			};

			const inputSuccess = (input) => {
				// let check = FormCheck.valSuccess(input, data, nullable);
				// console.log("input success: ::");
				// console.log(check);
				// formState.disable = check;
			};

			// ? duplicating City Stay component
			const addComponent = () => {
				componentCount.count = [
					...componentCount.count,
					componentCount.count[componentCount.count.length - 1] + 1,
				];
			};
			const removeComponent = (id) => {
				data.cities = data.cities.filter((city) => city.id !== id);
				const newCount = componentCount.count.filter((count) => count !== id);
				componentCount.count = newCount;
			};

			const updateData = (payload) => {
				if (data.cities.length) {
					let found = false;
					data.cities.map((city) => {
						if (city.id === payload.id && city.city.id === payload.city.id) {
							city.city.id = payload.city.id;
							city.city.name = payload.city.name;
							city.stayNights = payload.stayNights;
							found = true;
						}
					});

					if (!found) {
						data.cities = [...data.cities, payload];
					}
				} else {
					data.cities = [...data.cities, payload];
				}
			};

			const setImage = (images) => {
				if (!images.length) return;
				data.images = [...images];
				formState.disable = false;
			};

			const setPackageDealDataObj = (key, payload) => {
				try {
					if (!payload instanceof Object) return;
					if (Array.isArray(data[key]) && data[key].length) {
						
						data[key] = data[key].filter(
							(packageDeal) => packageDeal.id !== payload.id 
						);

						data[key] = [...data[key], { ...payload }];
						return
					}
					data[key] = [...data[key], { ...payload }];
				} catch (error) {
					console.log("error in setPackageDeal")
				}
 				
			} 

			const setLuxuryPackage = (payload) => {
				setPackageDealDataObj("luxuryPackage", payload)
			};

			const setGoldPackage = (payload) => {
				setPackageDealDataObj("goldPackage", payload);

			};
			const setSilverPackage = (payload) => {
				setPackageDealDataObj("silverPackage", payload);
			};
			const setPlatinumPackage = (payload) => {
				setPackageDealDataObj("platinumPackage", payload);

			};
			const setBronzePackage = (payload) => {
				setPackageDealDataObj("bronzePackage", payload);
			};
			const removePackage = (dataObj) => {
				if (!dataObj.dealName || !dataObj.id) return;
				try {
					if (Object.prototype.hasOwnProperty.call(data, dataObj.dealName)) new Error(`Unknown key error:  ${dataObj.dealName} is not defined on data object`);
					data[`${dataObj.dealName}Package`] = data[`${dataObj.dealName}Package`].filter(
						(deal) => deal.id !== dataObj.id,
					);
				} catch (error) {
					console.log("error removing package deal");
				}
				
			};

			return {
				data,
				image,
				multiSelectState,
				componentCount,
				radioCheckData,
				seasonDates,

				addComponent,
				removeComponent,
				updateData,

				createPackage,

				inputError,
				inputSuccess,

				formState,

				getCountries,
				setCountry,
				setTags,
				setExclusion,
				setInclusion,
				setImage,
				setLuxuryPackage,
				setGoldPackage,
				setSilverPackage,
				setPlatinumPackage,
				setBronzePackage,
				removePackage,
			};
		},
	};
</script>
<style scoped>
	.text-dark custom-rounded-15 shadow-lg mt-4 py-3 {
		padding: 10px 15px 10px 5px;
		background-color: white !important;
		border-radius: 4px;
		cursor: pointer;
		border-bottom: 1px solid #eee !important;
		margin-bottom: 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.v-enter-active,
	.v-leave-active {
		opacity: 1;
		transform: translateY(0);
		transition: transform 0.4s ease-in-out;
	}
	.v-enter-from,
	.v-leave-to {
		opacity: 0;
		transform: translateY(20%);
		transition: transform 0.4s ease-in-out;
	}
</style>
